module.exports = __webpack_public_path__ + "static/media/raid__fantasy--bg.ae1a700c.jpg";